<template lang="pug" src="./sqlReportsEditor.pug"></template>
<style lang="scss" src="./sqlReportsEditor.scss"></style>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import validate from '@/mixins/validate'
import { mapState } from 'vuex'
import request from '@/utils/request'

export default {
    mixins: [validate, validationMixin],
    data: () => ({
        report: {
            name: null,
            categoryId: null,
            sqlQuery: null,
            meta: null,
            useDates: null,
            useTimes: null,
            useQuery: null,
            forLeader: false
        },
        availablePermissions: [],
        canSaveChanges: false,
        removeModal: false
    }),
    validations: {
        report: {
            name: {
                required
            },
            sqlQuery: {
                required
            }
        }
    },
    computed: {
        ...mapState({
            reports: state => state.sqlReports.reportsList,
            categories: state => state.sqlReports.roleCategories
        }),
        isEditingMode() {
            return !!this.$route.params.id
        },
        saveText() {
            return this.isEditingMode ? 'update' : 'create'
        },
        saveAction() {
            return this.isEditingMode ? 'updateReport' : 'createReport'
        },
        reportCategoryId: {
            get() {
                return this.report.categoryId
            },
            set(val) {
                this.$set(this.report, 'categoryId', val || null)
            }
        }
    },
    watch: {
        report: {
            handler: function() {
                this.canSaveChanges = true
            },
            deep: true
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        async loadData() {
            await this.$store.dispatch('sqlReports/getReportsCategories', false)

            if (this.isEditingMode) {
                const reportId = this.$route.params.id

                await request({
                    method: 'get',
                    url: `/sql-reports/${reportId}`
                }).then(res => {
                    if (res.data) {
                        this.processResponseData(res.data)
                    }
                }).catch(error => this.errorHandler(error))
            }
        },
        processResponseData(data) {
            this.report = Object.assign({}, Object.select(data, [
                'id', ...Object.keys(this.report)
            ]))

            if (this.report.id && !this.isEditingMode) {
                this.$router.push(`/extended-reports/editor/${this.report.id}`)
            }

            this.$nextTick(() => {
                this.canSaveChanges = false
            })
        },
        errorHandler(error) {
            const errorData = error.response && error.response.data

            if (errorData && errorData.code === 404) {
                this.$router.push('/extended-reports/editor')
            }

            if (errorData && errorData.message) {
                this.$store.dispatch('addMessage', {
                    type: 'error',
                    message: error.response.data.message
                }, { root: true })
            }
        },
        async saveChanges() {
            if (this.$v.report.$invalid) {
                this.$v.report.$touch()
                return
            }

            await this.$store.dispatch(`sqlReports/${this.saveAction}`, Object.assign({}, {
                ...this.report
            })).then(res => {
                if (res.status === 200 && res.data) {
                    this.processResponseData(res.data)
                }
            })
        },
        removeReport() {
            this.$store.dispatch('sqlReports/removeReport', this.report.id).then(() => {
                this.$nextTick(() => {
                    this.removeModal = false

                    this.$router.push('/extended-reports/list')
                })
            })
        }
    }
}
</script>
